export const facialRecognition = {
  'All right!': '¡Todo bien!',
  'We’ve confirmed your identity! You can keep enjoying a hair-free life with us!':
    '¡Confirmamos tu identidad! ¡Ya podés seguir disfrutando de una vida sin vellos con nosotros!',
};
